module.exports = __webpack_public_path__ + "static/media/language-selector-check.fe85ebb1.svg";